import React, { useState } from "react";
import DataTable from "components/DataTable";
import { useTableDataWithPost } from "../../hooks/useTableWithPost";
import { useSession } from "hooks/useSession";

// ── Deleted Members Table Config ──
const DeletedMembersConfig = {
  title:   "Deleted Members",
  columns: [
    { key: "id",           label: "ID"           },
    { key: "name",         label: "Name"         },
    { key: "Email",        label: "Email"        },
    { key: "Phone",        label: "Phone"        },
    { key: "Role",         label: "Role"         },
    { key: "wallet_amount",label: "Wallet"       },
    { key: "joining_date", label: "Joining Date" },
    { key: "deleted_at",   label: "Deleted At"   },
  ],
};

const DeletedMembersPage = () => {
  const { userid }    = useSession();
  const [refresh]     = useState(0);
  const role          = localStorage.getItem("role");

  const formdata = new FormData();
  formdata.append("action",    "GETDELETED");
  formdata.append("role_name", role);
  formdata.append("userid",    userid);

  const tableData = useTableDataWithPost(
    "https://pro.mokshiq.in/retailer_action",
    DeletedMembersConfig,
    formdata,
    refresh
  );

  return (
    <main>
      <div className="container-fluid">
        <div className="row m-1 mb-4">
          <div className="col-12 d-flex justify-content-between align-items-center">
            <div>
              <h4 className="main-title fw-bold" style={{ color: "#1a1a1a", fontSize: "1.8rem", marginBottom: "4px" }}>Deleted Members</h4>
              <div className="d-flex align-items-center gap-2 mb-0" style={{ fontSize: "13.5px", fontWeight: "500" }}>
                <a href="#" className="text-decoration-none" style={{ color: "#7e57c2", display: "flex", alignItems: "center" }}>
                  <i className="ph-duotone ph-users f-s-16"></i> <span className="ms-1">Members</span>
                </a>
                <span style={{ color: "#a0a5b1" }}>/</span>
                <a href="#" className="text-decoration-none" style={{ color: "#7e57c2" }}>
                  Deleted Members
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="row m-1">
          <div className="col-12">
            <div className="card border-0" style={{ borderRadius: "12px", boxShadow: "0 2px 12px rgba(0,0,0,0.04)" }}>
              <div className="card-body p-4">
                <div style={{
                  backgroundColor: "#fee2e2", borderRadius: "12px", padding: "16px 24px",
                  marginBottom: "24px", display: "flex", alignItems: "center", justifyContent: "space-between"
                }}>
                  <div className="d-flex align-items-center gap-3">
                    <div style={{
                      background: "#fecaca", borderRadius: "12px", width: "48px", height: "48px",
                      display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0
                    }}>
                      <span style={{ fontSize: "24px" }}>🗑️</span>
                    </div>
                    <div>
                      <h5 style={{ margin: 0, fontWeight: "600", color: "#991b1b" }}>Deleted Members List</h5>
                      <span style={{ fontSize: "14px", color: "#b91c1c" }}>View and restore deleted member accounts</span>
                    </div>
                  </div>
                  <span className="badge" style={{ backgroundColor: "#ef4444", fontSize: "14px", padding: "8px 12px", borderRadius: "8px" }}>
                    {tableData?.data?.length || 0} Deleted
                  </span>
                </div>

                <DataTable
                  config={DeletedMembersConfig}
                  tableData={tableData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default DeletedMembersPage;